import { useSelector } from "react-redux";
import { useEffect, useCallback, useState } from "react";

export default useReduxSwr;

type fetcherFn<Data> = (...args: any) => Promise<Data>;

interface Options<Data = any> {
  fetcher: fetcherFn<Data>;
  selector: (state: any) => any;
  onStart?: () => void;
  onFinished?: (data: any) => void;
  onFailed?: (err: any) => void;
  enabled?: boolean;
}

function useReduxSwr<Data = any>(options: Options) {
  let {
    fetcher,
    selector,
    onStart,
    onFinished,
    onFailed,
    enabled = true,
  } = options;
  let data: Data = useSelector<any, any>(selector);
  let [error, setError] = useState();
  let [isLoading, setLoading] = useState(false);
  let revalidate = useCallback(
    function revalidate_memo() {
      if (onStart) {
        onStart();
      }
      setLoading(true);

      return fetcher()
        .then((data) => {
          if (onFinished) {
            onFinished(data);
          }
          return data;
        })
        .catch((e: any) => {
          setError(e);
          if (onFailed) {
            onFailed(e);
          }
          return e;
        })
        .finally(() => {
          setLoading(false);
        });
    },
    [onStart, fetcher, onFinished, onFailed]
  );

  useEffect(() => {
    if (enabled) {
      revalidate();
    }
  }, []);
  // get from server (needs a `fetcher`)
  // store in redux (dispach `successful` action)
  // read from redux (use `selector`)
  // revalidate from server
  return {
    error,
    isValidating: isLoading,
    data,
    revalidate,
  };
}
